import Api from '@/lib/api'

export default {
    namespaced: true,
    state: {
        groups: [],
        grades: [],
        statuses: {
            approved: 'Approved',
            pending: 'Pending',
            declined: 'Declined'
        }
    },
    mutations: {
        setGroups(state, payload) {
            state.groups = payload
        },
        setGrades(state, payload) {
            state.grades = payload
        }
    },
    actions: {
        getSubjects({ commit }) {
            return Api()
                .get('groupsCms', {
                    params: {
                        _fields: '_id,name,school._id,school.name'
                    }
                })
                .then(response => {
                    const list = response.data.result.map(item => {
                        return { id: item._id, name: item.name }
                    })

                    commit('setGroups', list)
                })
        },
        getGroups({ commit }, payload) {
            return Api()
                .get('groupsCms', {
                    params: {
                        _fields: '_id,name,school._id,school.name',
                        schoolId: payload
                    }
                })
                .then(response => {
                    const list = response.data.result.map(item => {
                        return { id: item._id, name: item.name }
                    })

                    commit('setGroups', list)
                })
        },
        getGrades({ commit }, payload) {
            return Api()
                .get('gradesCms', {
                    params: {
                        _fields: '_id,name,school._id,school.name',
                        schoolId: payload
                    }
                })
                .then(response => {
                    const list = response.data.result.map(item => {
                        return { id: item._id, name: item.name }
                    })

                    commit('setGrades', list)
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/subjects.js